export * from './link-data.observer';
